import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SiteInfo, SiteInfoAuth, SiteInfoBranding, SiteInfoGeneral } from '../../models/site-info.model';

@Injectable({
  providedIn: 'root'
})
export class SiteInfoService {
  constructor(private http: HttpClient) {}
  
  async getSiteInfo(): Promise<SiteInfo> {
    let siteInfo = sessionStorage.getItem('SiteInfo')
    if (siteInfo){
      return new SiteInfo(JSON.parse(siteInfo))
    }
    const r = await this.http.get(`/api/site-info`).toPromise()
    sessionStorage.setItem('SiteInfo', JSON.stringify(r))

    return new SiteInfo(r)
  }

  async getSiteInfoGeneral(): Promise<SiteInfoGeneral> {
    let siteInfoGeneral = sessionStorage.getItem('SiteInfoGeneral')
    if (siteInfoGeneral){
      return new SiteInfoGeneral(JSON.parse(siteInfoGeneral))
    }
    const r = await this.http.get(`/api/site-info/general`).toPromise()
    sessionStorage.setItem('SiteInfoGeneral', JSON.stringify(r))

    return new SiteInfoGeneral(r)
  }

  async getSiteInfoAuth(): Promise<SiteInfoAuth> {

    const r = await this.http.get(`/api/site-info/auth`).toPromise()
    
    return new SiteInfoAuth(r)
  }

  async getSiteInfoBranding(): Promise<SiteInfoBranding> {
    let branding = sessionStorage.getItem('SiteInfoBranding')
    if (branding){
      return new SiteInfoBranding(JSON.parse(branding))
    }
    const r = await this.http.get(`/api/site-info/branding`).toPromise()
    sessionStorage.setItem('SiteInfoBranding', JSON.stringify(r))
    return new SiteInfoBranding(r)
  }
}
